import { cva, type VariantProps } from 'class-variance-authority';

export const spinnerVariants = cva(
  'border-transparent animate-spin rounded-[50%] border-4',
  {
    variants: {
      variant: {
        white: 'border-t-neutral-50',
        blue: 'border-t-blue-500',
      },
      size: {
        small: 'h-10 w-10 border-[6px]',
        medium: 'h-[50px] w-[50px]',
        large: 'h-[100px] w-[100px]',
      },
    },
    defaultVariants: {
      variant: 'white',
      size: 'small',
    },
  },
);

export type SpinnerVariantProps = VariantProps<typeof spinnerVariants>;
